import { render, staticRenderFns } from "./NoOrders.vue?vue&type=template&id=46b28f36&scoped=true"
import script from "./NoOrders.vue?vue&type=script&lang=ts"
export * from "./NoOrders.vue?vue&type=script&lang=ts"
import style0 from "./NoOrders.vue?vue&type=style&index=0&id=46b28f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b28f36",
  null
  
)

export default component.exports